module.exports = __webpack_public_path__ + "img/super_xtra.8b1bc55b.png";